import { useStoreSelector } from 'v3/data/store';
import { GroupAdminProductsListPage } from 'v3/pages/Products/List/groupAdmin';
import { MasterAdminProductsListPage } from 'v3/pages/Products/List/masterAdmin';
import { StoreProductsListPage } from 'v3/pages/Products/List/store';
import { DefaultTemplate } from 'v3/shared/templates/DefaultTemplate';

export const ProductsListPage = () => {
  const { group } = useStoreSelector((store) => store.store.storeLogged);

  const resultByProfile = {
    store: <StoreProductsListPage />,
    groupAdmin: <GroupAdminProductsListPage />,
    masterAdmin: <MasterAdminProductsListPage />,
  };

  return <DefaultTemplate>{resultByProfile[group]}</DefaultTemplate>;
};
